import _str from "shared/util/_str";

export const OKCUPID_SYSTEM_USERID = "0";
export const ALICE_USERID = "4170169657126759250";

export const PLACEHOLDER_COUNT_MESSAGES = 5;
export const PLACEHOLDER_COUNT_USERS = process.env.PLATFORM === "desktop" ? 3 : 7;

export const INACTIVE_MESSAGES_BUTTON_TEXT = _str("Old Conversations");

export const MESSAGE_FOLDERS = {
	INCOMING: "INCOMING",
	ARCHIVED: "ARCHIVED",
};

export const APP_EVENT_TYPES = {
	pageShow: "pageShow",
	userBlockedEvent: "userBlockedEvent",
	userHiddenEvent: "userHiddenEvent",
	userPassedEvent: "userPassedEvent",
	conversationDeletedEvent: "conversationDeletedEvent",
	userMessagedEvent: "userMessagedEvent",
};



// WEBPACK FOOTER //
// ./src/apps/messages/util/constants.js